import React, { useEffect } from 'react'
import EmptyBox from '../MyRecords/EmptyBox'

export default ({ searchTerm, hidden }) => {
  useEffect(() => {
    !hidden && document.getElementById('empty-placeholder').focus()
  }, [searchTerm, hidden])
  return (
    <div
      tabIndex={-1}
      id="empty-placeholder"
      role="alert"
      aria-live="assertive"
      className="empty-placeholder-wrapper"
      style={{ display: hidden ? 'none' : 'flex' }}>
      <EmptyBox />
      <h2>No results were found {searchTerm && ' for ' + searchTerm}</h2>
      <p>Try your search again with different filters or a different search term.</p>
    </div>
  )
}
